import { render, staticRenderFns } from "./form-cadastro.vue?vue&type=template&id=beb9d6ce"
import script from "./form-cadastro.vue?vue&type=script&lang=js"
export * from "./form-cadastro.vue?vue&type=script&lang=js"
import style0 from "./form-cadastro.vue?vue&type=style&index=0&id=beb9d6ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports